import { lazy } from 'react';

export const CatalogMatchJobsPageAsync = lazy(
  () => import('./CatalogMatchJobs'),
);
